<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('information.fee.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('information.title') }} > </span>
            <span class="middle_loc">{{ $t('information.fee.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.list') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">


          <div class="top__component__fold__wrap" v-if="component_fold">
            <v-row class="top_search_content2">
              <v-col cols="12" md="8">
                <label class="nec_title">{{ $t('information.fee.fields.title_fee_name') }}</label>

                <div class="input_text_type_basic">
                  <v-text-field
                    placeholder=""
                    dense
                    outlined
                    hide-details
                    clearable
                    class="ft-size12 wp100"
                    v-model="searchOption.searchKeyword"
                  >
                  </v-text-field>
                </div>
                <v-spacer class="hidden_lr5"></v-spacer>
              </v-col>
              <v-col cols="12" md="4" class="mobile__dcolumn">
                <v-btn class="t_search_btn wp50" color="#a01c2a" dark height="40" @click="fnGetFeeList()">
                  <v-icon>mdi-magnify</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.search') }}
                </v-btn>
                <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                <v-btn class="t_search_btn wp50" color="#222" dense dark height="40" @click="fnReset()">
                  <v-icon>mdi-restart</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.reset') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <!-- 상단 레이아웃 접는 기능영역 : S -->
          <div class="fold__actions__wrap">
            <v-btn @click="foldingActions()" :class="{actv : component_fold}" color="#dedede" small min-width="120px"><v-icon x-small color="#727272">mdi-triangle</v-icon></v-btn>
          </div>
          <!-- 상단 레이아웃 접는 기능영역 : E -->

          <v-data-table
            :headers="$getHeaderType1(headerTxt, headers)"
            :items="feeList"
            hide-default-footer
            class="elevation-0 myapp_table_type2 type4 mt-30"
            :page.sync="paging.page"
            :items-per-page="paging.pageSize"
            @page-count="paging.pageCount = $event"
            :mobile-breakpoint="MobileBreakPoint"
          >
          <template v-slot:item="{ item }">
              <tr :class="{'notice' : item.ind_top == 'Y'}">
                <td :class="$vuetify.rtl ? 'text-right' : 'text-left'" style="cursor:pointer;" @click="fnGoFeeView(item.seq)">
                  {{ $vuetify.rtl ? item.subject_ar : (fnIsNull(item.subject_en) ? item.subject_ar : item.subject_en) }}
                </td>
                <td class="text-center" style="cursor:pointer;">{{ item.write_date }}</td>
                <td style="cursor:pointer;">{{ item.read_count }}</td>
              </tr>
          </template>
          </v-data-table>

          <div class="v-data-table board_basic_wrap theme--light mb-30">
            <div class="v-data-table-footer page_nation_wrap">
              <pagination :paging.sync="paging" />
            </div>
          </div>

        </v-flex>

      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import Pagination from '@/components/layout/Pagination'
import requestApi from '@/utils/requestApi'
import eventBus from '@/utils/eventBus'
import utils from '@/utils/utils'

export default {
  name : 'Fee',
  components :{
    Pagination
  },
  data () {
    return {
      MobileBreakPoint : 0,
      component_fold : false,
      headerTxt : {
        prefix : 'information.fee.fields.',
        txt : [ 'title','date','views' ]
      },

      headers: [
        { text: this.$t('information.fee.fields.title'), align: 'center', value: '',sortable: false, width:'70%'},
        { text: this.$t('information.fee.fields.date'), align: 'center', value: '',sortable: false, },
        { text: this.$t('information.fee.fields.views'),  align: 'center', value: '',sortable: false, },

      ],

      // 페이징 처리
      paging: {
        page: 1,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0
      },

      feeList : [],

      searchOption : {
        searchActiveTypeCode : '8001', // 이서비스는 사용자단이므로 활성화만 보여주기
        searchKeyword : ''
      }
    }
  },
  created() {

    if(!utils.isNull(this.$route.params.searchKeyword)){
      this.searchOption.searchKeyword = this.$route.params.searchKeyword
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    // 폴딩 브라우저 사이즈 체크 하여 접고 여는 부분 체크
    this.onResize()
    //window.addEventListener('resize', this.onResize, { passive: true })

    this.fnInit()
  },
  beforeDestroy (){
    // 리사이징 이벤트 제거
    if (typeof window === 'undefined') {
      return
    }
    window.removeEventListener('resize', this.onResize, { passive: true });
  },
  methods: {
    onResize () {
      this.component_fold = window.innerWidth < 960 ? false : true
    },
    foldingActions(){
      this.component_fold = !this.component_fold
    },
    fnInit() {
      this.fnGetFeeList()
    },
    fnReset(){
      this.searchOption.searchKeyword = ''
    },
    fnGetFeeList(){
      requestApi({
        url: '/info/fee',
        method: 'GET',
        data: this.searchOption,
        callback: (res) => {
          if (res.res_code === '200') {

            this.feeList = res.data.list
            this.paging.totalCount = res.data.list.length

            if(!utils.isNull(this.$route.params.page)){
              this.paging.page = this.$route.params.page
            }
            if(!utils.isNull(this.$route.params.pageSize)){
              this.paging.pageSize = this.$route.params.pageSize
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetFeeList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGoFeeView(seq){
      let page = {
        name : 'FeeView',
        params : {
          seq : seq,
          searchKeyword : this.searchOption.searchKeyword,
          page : this.paging.page,
          pageSize : this.paging.pageSize
        }
      }
      this.$router.push(page)
    },
    fnIsNull(val){
      return utils.isNull(val)
    },
  }
}
</script>